/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2017
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define(['../../app/nls/StringResources'], function(stringResources){
	return {
		layout: {
			type: 'tab',
			layoutPositioning: 'relative',
			items: [ {
				type: 'absolute',
				title: stringResources.get('defaultTabTitle', {
					index: 1
				})
			}],
			style: {
				height: '100%'
			},
			pageSize: {
				width: 1280,
				height: 720
			},
			showGrid: true,
			snapGrid: true,
			snapObjects: true
		}
	};
});
